import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Compass } from "lucide-react";
import { Button } from "../components/ui/button";

export default function NotFound() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-[#0A0A0A] text-white pt-32 pb-24 min-h-[80vh] relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-40" />
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-[420px] w-[520px] rounded-full bg-[#D4AF37]/10 blur-3xl" />
      <div className="relative max-w-3xl mx-auto px-5 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass border border-white/10 mb-7" data-testid="notfound-badge">
          <Compass className="h-3.5 w-3.5 text-[#D4AF37]" />
          <span className="text-xs font-medium tracking-wide text-gray-300">Page Not Found</span>
        </div>
        <h1 className="font-display text-6xl md:text-7xl lg:text-8xl font-bold leading-none mb-5">
          4<span className="text-gradient-brand">0</span>4
        </h1>
        <p className="text-lg text-gray-300 max-w-xl mx-auto mb-8">
          The page you're looking for has moved or doesn't exist. Let's get you back on track — or better, let's talk about your business.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" data-testid="notfound-home-cta">
            <Button className="bg-gradient-brand text-[#0A0A0A] rounded-full h-12 px-7 font-semibold">
              Back to Home
            </Button>
          </Link>
          <Link to="/contact" data-testid="notfound-contact-cta">
            <Button variant="outline" className="border-white/20 bg-white/5 hover:bg-white/10 text-white rounded-full h-12 px-7 font-semibold">
              Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
